module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-creative-03.7dd55294.jpg";